import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Card } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useI18n } from '../i18n/I18nContext';
import CreateInvoiceForm from '../components/CreateInvoiceForm';
import './CreateInvoice.css';

const { Title, Paragraph } = Typography;

const CreateInvoice: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [showingSuccess, setShowingSuccess] = useState(false);

  return (
    <div className="create-invoice-page">
      <div className="create-invoice-header">
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/app/invoices')}
          className="back-button"
        >
          {t.app.createInvoice.back}
        </Button>
        <Title level={1} className="create-invoice-title">
          {showingSuccess ? t.app.createInvoice.successTitle : t.app.createInvoice.title}
        </Title>
        <Paragraph className="create-invoice-subtitle">
          {showingSuccess ? t.app.createInvoice.successSubtitle : t.app.createInvoice.subtitle}
        </Paragraph>
      </div>

      <Card className={showingSuccess ? 'invoice-link-card' : 'create-invoice-card'}>
        <CreateInvoiceForm
          onCancel={() => navigate('/app/invoices')}
          onViewInvoices={() => navigate('/app/invoices')}
          onSuccessViewChange={setShowingSuccess}
        />
      </Card>
    </div>
  );
};

export default CreateInvoice;
